import { REQUIRED_FIELD } from "@/lib/constants";
import moment from "moment";

const validations = {
  passwordStrength: {
    value: /^(?=.*?[A-Z])(?=.*?[a-z])(?=.*?[0-9])(?=.*?[#?!@$%^&*-]).{8,}$/,
    message:
      "Password must be 8 or more characters long, contain at least one capital, one lowercase, one number and one non-alphanumeric symbol (eg. Sw1ftmedic@l)",
  },
  name: {
    value: /^[A-Za-z\s'-]+$/,
    message: "Please enter only letters, dashes, or apostrophes.",
  },
  email: {
    value: /\S+@\S+\.\S+/,
    message: "Please enter a valid email address.",
  },
  username: {
    value: /^[A-Za-z][A-Za-z0-9]*$/,
    message:
      "Please enter a username that starts with a letter and only contains letters and numbers.",
  },
  dateOfBirth: (value: string) => {
    if (!moment(value, moment.ISO_8601, true).isValid()) {
      return "Please enter a valid date.";
    }
    if (new Date(value) >= new Date()) {
      return "Date cannot be in the future.";
    }
    return true;
  },
  booleanExists: (val?: any) => {
    return val === true || val === false ? true : REQUIRED_FIELD;
  },
};

export default validations;
